export type ClubPlanId = "digital";

export interface ClubJoinOption {
  id: ClubPlanId;
  name: string;
  price: string;
  billingNote: string;
  detail: string;
  productPath: string;
  image: string;
  checkoutUrl: string;
}

export const CLUB_JOIN_OPTIONS: ClubJoinOption[] = [
  {
    id: "digital",
    name: "Digital Agency Membership",
    price: "$6",
    billingNote: "per month",
    detail:
      "Instant digital delivery each month. Unlock your next case and keep your archive access active.",
    productPath: import.meta.env.VITE_CLUB_PRODUCT_PATH_DIGITAL || "club-case-d",
    image:
      "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?auto=format&fit=crop&w=1200&q=80",
    checkoutUrl: import.meta.env.VITE_CLUB_JOIN_URL_DIGITAL || "",
  },
];

export const getClubJoinOption = (planId: string | null | undefined) =>
  CLUB_JOIN_OPTIONS.find((option) => option.id === planId);

declare global {
  interface Window {
    fastspring?: {
      builder?: {
        reset?: () => void;
        add?: (productId: string) => void;
        checkout?: () => void;
      };
    };
  }
}

export const launchClubCheckout = (option: ClubJoinOption) => {
  const fastspringBuilder = window.fastspring?.builder;
  if (fastspringBuilder?.add && fastspringBuilder?.checkout) {
    fastspringBuilder.reset?.();
    fastspringBuilder.add(option.productPath);
    fastspringBuilder.checkout();
    return { launched: true as const, method: "builder" as const };
  }

  if (option.checkoutUrl) {
    window.location.href = option.checkoutUrl;
    return { launched: true as const, method: "url" as const };
  }

  return { launched: false as const, method: "none" as const };
};
